<template>
  <div>
    <WebHeaderView :title="$t('menu.mine')" />
    <div class="page-content">
      <div class="mine-box">
        <MineHeadView :usr="usr" :vip="vip" />
        <MineBalanceView :usr="usr" @refresh="dorefresh()" />
        <MineGridView />
        <MineMenuView />
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
import {
  MineHeadView,
  MineBalanceView,
  MineGridView,
  MineMenuView
} from './components/index'
export default {
  name: 'MineView',
  components: {
    WebHeaderView,
    MineHeadView,
    MineBalanceView,
    MineGridView,
    MineMenuView
  },
  data(){
    return {
        usr:{},
        vip:null,
        bfNum:0
    }
  },
  mounted(){
    this.getusrInf()
   
  },
  methods:{
    dorefresh(){
        this.getusrInf()
    },
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        this.usr = data.data
        this.getusrVip()
      })
    },
    async getusrVip () {
      await this.$http({
        method: 'post',
        url: 'usrVip'
      }).then(data => {
         this.vip = data.data
      })
    },
    
  }
}
</script>
<style lang="scss" scoped>
.mine-box {
  padding: 15px 15px;
}
</style>
